import { combineReducers } from 'redux'

import gerenciadorContratos from './gerenciadorContratos'
import cadastroFuncionario from './cadastroFuncionario'

export default combineReducers({
  gerenciadorContratos,
  cadastroFuncionario
})
